import { Card, CardProps } from '@mui/material';
import './ccf-card.module.scss';

/* eslint-disable-next-line */
export interface CcfCardProps extends CardProps{}

/**
 * Functional component is a wrapper for material UI card component
 * @param param0 -CcfCardProps
 * @returns material UI card element
 * @example <CcfCard/>
 */
export function CcfCard({children,...other}: CcfCardProps) {
  return (
    <Card {...other} >
      {children}
    </Card>
  );
}

export default CcfCard;
